import { useMutation, useSubscription } from "@apollo/react-hooks"
import { generateDateRange } from "Methods/date"
import { generateBoardTime } from "Methods/board"
import { PushBoard, PushChildBoard, PushVideoBoard, PushPhotoBoard, PushBeautyBoard, PushSpeciesBoard, PushEatBoard, PushHealthBoard } from "Types/board"
import { generateMutation, generateSubscription } from "Methods/query"
import request from "Methods/request"
import { CalendarType } from "Types/channel"
import { TableName } from "Types/table"
// 订阅渠道下所有预约
const material = `material {
    id
    status
  }`
const boardName: { [any: string]: TableName } = {
    '微信': 'wechat_board',
    '童学馆': 'child_board',
    '果壳视频': 'video_board',
    '摄影': 'photo_board',
    '美丽': 'beauty_board',
    '果壳自然': 'species_board',
    '吃货': 'eat_board',
    '果壳病人': 'health_board',
}

const boardValue: { [any: string]: string } = {
    '微信': `${material} creator_info { nickname department { name color type_name } role { role_name }} channel { name } author { name uid hidden } article_type { name color_code hidden } principal_user { nickname department { name color type_name } role { role_name }}`,
    '童学馆': `creator_info { nickname department { name color } role { role_name }} channel { name } child_article_type { name color_code hidden }`,
    '果壳视频': `creator_info { nickname department { name color } role { role_name }} channel { name } `,
    '摄影': `creator_info { nickname department { name color } role { role_name }} channel { name } photo_article_type { name color_code hidden }`,
    '美丽': `creator_info { nickname department { name color } role { role_name }} channel { name } beauty_article_type { name color_code hidden }`,
    '果壳自然': `${material} creator_info { nickname department { name color type_name } role { role_name }} channel { name } article_type { name color_code hidden }`,
    '吃货': `creator_info { nickname department { name color } role { role_name }} channel { name } eat_article_type { name color_code hidden }`,
    '果壳病人': `${material} creator_info { nickname department { name color type_name } role { role_name }} channel { name } article_type { name color_code hidden }`,
}

const boardWhere: { [any: string]: (currentDate: Date) => {} } = {
    '童学馆': (currentDate) => {
        const dateRange = generateDateRange(currentDate)
        return {
            ad_time: {
                _gte: dateRange[0],
                _lte: dateRange[dateRange.length - 1],
            },
        }
    },
    '果壳视频': (currentDate) => {
        const dateRange = generateDateRange(currentDate)
        return {
            ad_time: {
                _gte: dateRange[0],
                _lte: dateRange[dateRange.length - 1],
            },
        }
    },
    '摄影': (currentDate) => {
        const dateRange = generateDateRange(currentDate)
        return {
            ad_time: {
                _gte: dateRange[0],
                _lte: dateRange[dateRange.length - 1],
            },
        }
    },
    '美丽': (currentDate) => {
        const dateRange = generateDateRange(currentDate)
        return {
            ad_time: {
                _gte: dateRange[0],
                _lte: dateRange[dateRange.length - 1],
            },
        }
    },
    '果壳自然': (currentDate) => {
        const dateRange = generateDateRange(currentDate)
        return {
            ad_time: {
                _gte: dateRange[0],
                _lte: dateRange[dateRange.length - 1],
            },
            is_draft: {
            _eq: false,
            },
        }
    },
    '吃货': (currentDate) => {
        const dateRange = generateDateRange(currentDate)
        return {
            ad_time: {
                _gte: dateRange[0],
                _lte: dateRange[dateRange.length - 1],
            },
            is_draft: {
                _eq: false,
            },
        }
    },
    '果壳病人': (currentDate) => {
        const dateRange = generateDateRange(currentDate)
        return {
            ad_time: {
                _gte: dateRange[0],
                _lte: dateRange[dateRange.length - 1],
            },
            is_draft: {
            _eq: false,
            },
        }
    },
}
export function useSubscribeBoard(channelName: string, currentDate: Date) {
    const tableName = boardName[channelName] || "board"
    const returnValue = boardValue[channelName] || `${material} creator_info { nickname department { name color }} channel { name } article_type { color_code hidden }`
    const boardMutation = generateSubscription(tableName, returnValue)
    const dateRange = generateDateRange(currentDate)
    const whereQuery = boardWhere[channelName] && boardWhere[channelName](currentDate) || {
        ad_time: {
            _gte: dateRange[0],
            _lte: dateRange[dateRange.length - 1],
        },
        is_draft: {
            _eq: false,
        },
    }
    try {
        const res = useSubscription(boardMutation, {
            variables: {
                where: whereQuery,
            },
        })
        return { board: res.data ? res.data[tableName] || [] : [], loading: res.loading }
    } catch (e) {
        return { board: [], loading: false }
    }
}
// 创建预约
export function useAddBoard() {
    const add = async (data: PushBoard | null) => {
        try {
            await request.post(`/apis/boards`, {
                ...data,
                ad_times: generateBoardTime(data),
            })
        } catch (e) {
            throw e
        }
    }
    return { add }
}
// 创建微信预约
export function useAddWeChatBoard() {
    const add = async (data: PushBoard | null) => {
        try {
            await request.post(`/apis/wechat_boards`, {
                ...data,
                ad_times: generateBoardTime(data),
            })
        } catch (e) {
            throw e
        }
    }
    return { add }
}
// 创建童学馆预约
export function useAddChildBoard() {
    const add = async (data: PushChildBoard | null) => {
        try {
            await request.post(`/apis/child_boards`, {
                ...data,
                ad_time: new Date(data && data.ad_time || ''),
            })
        } catch (e) {
            throw e
        }
    }
    return { add }
}
// 创建物种预约
export function useAddSpeciesBoard() {
    const add = async (data: PushSpeciesBoard | null) => {
        try {
            await request.post(`/apis/species_boards`, {
                ...data,
                ad_time: new Date(data && data.ad_time || ''),
            })
        } catch (e) {
            throw e
        }
    }
    return { add }
}
// 创建吃货预约
export function useAddEatBoard() {
    const add = async (data: PushEatBoard | null) => {
        try {
            await request.post(`/apis/eat_boards`, {
                ...data,
                ad_time: new Date(data && data.ad_time || ''),
            })
        } catch (e) {
            throw e
        }
    }
    return { add }
}

// 创建美丽预约
export function useAddBeautyBoard() {
    const add = async (data: PushBeautyBoard | null) => {
        try {
            await request.post(`/apis/beauty_boards`, {
                ...data,
                ad_time: new Date(data && data.ad_time || ''),
            })
        } catch (e) {
            throw e
        }
    }
    return { add }
}

// 创建视频预约
export function useAddVideoBoard() {
    const add = async (data: PushVideoBoard | null) => {
        try {
            await request.post(`/apis/video_boards`, {
                ...data,
                ad_time: new Date(data && data.ad_time || ''),
            })
        } catch (e) {
            throw e
        }
    }
    return { add }
}

export function useAddPhotoBoard() {
    const add = async (data: PushPhotoBoard | null) => {
        try {
            await request.post(`/apis/photo_boards`, {
                ...data,
                ad_time: new Date(data && data.ad_time || ''),
            })
        } catch (e) {
            throw e
        }
    }
    return { add }
}
// 创建病人预约
export function useAddHealthBoard() {
    const add = async (data: PushHealthBoard | null) => {
        try {
            await request.post(`/apis/health_boards`, {
                ...data,
                ad_time: new Date(data && data.ad_time || ''),
            })
        } catch (e) {
            throw e
        }
    }
    return { add }
}

// 修改预约
export function useUpdateBoard() {
    const onBoardEdit = generateMutation("update", "board", [
        { name: "id", type: "Int" },
        { name: "name", type: "String" },
        { name: "article_type_id", type: "Int" },
        { name: "content_type", type: "String" },
        { name: "is_lottery", type: "Boolean" },
        { name: "is_micro", type: "Boolean" },
        { name: "project_id", type: "String" },
        { name: "project_money", type: "String" },
    ])
    const [update] = useMutation(onBoardEdit)
    return { update }
}
// 修改预约时间
export function useUpdateBoardTime() {
    const onBoardEdit = generateMutation("update", "board", [
        { name: "id", type: "Int" },
        { name: "ad_time", type: "timestamptz" },
        { name: "ad_place_id", type: "Int" },
        { name: "is_draft", type: "Boolean" },
    ])
    const [update] = useMutation(onBoardEdit)
    return { update }
}

// 拖动预约时间
export function useUpdateSpeciesBoardTime() {
    const onBoardEdit = generateMutation("update", "species_board", [
        { name: "id", type: "Int" },
        { name: "ad_time", type: "timestamptz" },
        { name: "ad_place_id", type: "Int" },
        { name: "is_draft", type: "Boolean" },
        { name: "seq_id", type: "Int" },

    ])
    const [updateSpeciesTime] = useMutation(onBoardEdit)
    return { updateSpeciesTime }
}

// 拖动预约果壳病人时间
export function useUpdateHealthBoardTime() {
    const onBoardEdit = generateMutation("update", "health_board", [
        { name: "id", type: "Int" },
        { name: "ad_time", type: "timestamptz" },
        { name: "ad_place_id", type: "Int" },
        { name: "is_draft", type: "Boolean" },
        { name: "seq_id", type: "Int" },

    ])
    const [updateHealthTime] = useMutation(onBoardEdit)
    return { updateHealthTime }
}

// 修改预约
export function useUpdateChildBoard() {
    const onBoardEdit = generateMutation("update", "child_board", [
        { name: "id", type: "Int" },
        { name: "name", type: "String" },
        { name: "child_article_type_id", type: "Int" },
        { name: "project_id", type: "String" },
        { name: "project_money", type: "String" },
    ])
    const [update] = useMutation(onBoardEdit)
    return { update }
}

// 修改物种预约
export function useUpdateSpeciesBoard() {
    const onBoardEdit = generateMutation("update", "species_board", [
        { name: "id", type: "Int" },
        { name: "name", type: "String" },
        { name: "species_article_type_id", type: "Int" },
        { name: "project_id", type: "String" },
        { name: "project_money", type: "String" },
    ])
    const [update] = useMutation(onBoardEdit)
    return { update }
}

// 修改果壳病人预约
export function useUpdateHealthBoard() {
    const onBoardEdit = generateMutation("update", "health_board", [
        { name: "id", type: "Int" },
        { name: "name", type: "String" },
        { name: "health_article_type_id", type: "Int" },
        { name: "project_id", type: "String" },
        { name: "project_money", type: "String" },
    ])
    const [update] = useMutation(onBoardEdit)
    return { update }
}

// 修改吃货预约
export function useUpdateEatBoard() {
    const onBoardEdit = generateMutation("update", "eat_board", [
        { name: "id", type: "Int" },
        { name: "name", type: "String" },
        { name: "eat_article_type_id", type: "Int" },
        { name: "project_id", type: "String" },
        { name: "project_money", type: "String" },
    ])
    const [update] = useMutation(onBoardEdit)
    return { update }
}

export function useUpdateEatBoardTime() {
    const onBoardEdit = generateMutation("update", "eat_board", [
        { name: "id", type: "Int" },
        { name: "ad_time", type: "timestamptz" },
        { name: "ad_place_id", type: "Int" },
        { name: "is_draft", type: "Boolean" },
        { name: "seq_id", type: "Int" },

    ])
    const [updateEatTime] = useMutation(onBoardEdit)
    return { updateEatTime }
}

// 修改预约
export function useUpdateVideoBoard() {
    const onBoardEdit = generateMutation("update", "video_board", [
        { name: "id", type: "Int" },
        { name: "name", type: "String" },
        { name: "project_id", type: "String" },
        { name: "project_money", type: "String" },
    ])
    const [update] = useMutation(onBoardEdit)
    return { update }
}

// 修改预约
export function useUpdatePhotoBoard() {
    const onBoardEdit = generateMutation("update", "photo_board", [
        { name: "id", type: "Int" },
        { name: "name", type: "String" },
        { name: "photo_article_type_id", type: "Int" },
        { name: "project_id", type: "String" },
        { name: "project_money", type: "String" },
    ])
    const [update] = useMutation(onBoardEdit)
    return { update }
}
// 修改预约
export function useUpdateBeautyBoard() {
    const onBoardEdit = generateMutation("update", "beauty_board", [
        { name: "id", type: "Int" },
        { name: "name", type: "String" },
        { name: "beauty_article_type_id", type: "Int" },
    ])
    const [update] = useMutation(onBoardEdit)
    return { update }
}
export function useUpdateWeChatBoardTime() {
    interface Data {
        ad_time: Date,
        seq_id: number,
        description: string,
        author_id: number,
        article_type_id: number,
        is_draft: boolean,
        project_id?: string
        project_money?: string
    }
    const updateTime = async (
        boardId: number = 0, data: Data,
    ) => {
        try {
            await request.put(`/apis/wechat_board/${boardId}/update_time`, data)
        } catch (e) {
            throw e
        }
    }
    return { updateTime }
}
// 删除预约
export function useDeleteBoard(channelName?: string) {
    const tableName: TableName = boardName[channelName || ''] || "board"
    const onBoardDelete = generateMutation("delete", tableName, [{ name: "id", type: "Int" }])
    const [del] = useMutation(onBoardDelete)
    return { del }
}

/*
* 订阅日历下的预约
* 支持 pc，移动站点，app，微信，微博，母版
* */
interface Options {
    calendarType: CalendarType,
    date: Date,
}
export function useSubscribeCalendarBoard(options: Options) {
    const { calendarType, date } = options
    const dateRange = generateDateRange(date)
    let tableName: TableName  // 订阅表格名称
    let returnValue: string   // 返回的数据格式
    let whereQuery  // 查询语句
    if (calendarType === "preset") {
        tableName = "preset"
        returnValue = ""
        whereQuery = {}
    } else if (calendarType === "wechat") {
        tableName = "wechat_board"
        returnValue = "creator_info { nickname department { name color } role { role_name }} channel { name } author { name uid hidden } article_type { name color_code hidden }"
        whereQuery = {
            ad_time: {
                _gte: dateRange[0],
                _lte: dateRange[dateRange.length - 1],
            },
            is_draft: {
                _eq: false,
            },
        }
    } else {
        tableName = "board"
        returnValue = "creator_info { nickname department { name color }} channel { name } article_type { color_code hidden }"
        whereQuery = {
            ad_time: {
                _gte: dateRange[0],
                _lte: dateRange[dateRange.length - 1],
            },
        }
    }
    const mutation = generateSubscription(tableName, returnValue)
    const { data } = useSubscription(mutation, { variables: { where: whereQuery } })
    const { preset = [], board = [], wechat_board = [] } = data || {}
    if (calendarType === "preset") {
        return { calendarData: preset }
    } else if (calendarType === "wechat") {
        return { calendarData: wechat_board }
    } else {
        return { calendarData: board }
    }
}
